import {Eula, EulaState} from '../reducers/eula.reducer';
import {safelyToJS} from './utils';

export const selectAffiliateAgreement = (state): Eula =>
    safelyToJS(state.getIn(['eula', 'affiliate']));

export const selectConductAgreement = (state): Eula => safelyToJS(state.getIn(['eula', 'conduct']));

export const selectEula = (state): EulaState => safelyToJS(state.get('eula'));

export const selectEulasAccepted = (state): boolean => {
    const eula = state.get('eula').toJS();
    return eula.affiliate.accepted && eula.conduct.accepted;
};

export const selectEulasLoading = (state): boolean => {
    const affiliateLoading = state.getIn(['eula', 'affiliateLoading']);
    const conductLoading = state.getIn(['eula', 'conductLoading']);
    return affiliateLoading || conductLoading;
};
